module.exports = __webpack_public_path__ + "6d265aa319439db394c992768e4e3e2b.jpg";